import { Form } from 'antd';
import React from 'react';

import FormInput from '../Fields/FormInput';

interface FormInputFormItemProps {
    name: string | string[];
    value: string | null;
    setValue: (value: string) => void;
    placeholder?: string;
    style?: React.CSSProperties;
    required?: boolean;
}

const FormInputFormItem: React.FC<FormInputFormItemProps> = ({
    name,
    value,
    setValue,
    placeholder,
    style,
    required,
}) => {
    return (
        <Form.Item name={name} noStyle rules={[{ required: required, message: placeholder + ' is required' }]}>
            <FormInput
                value={value}
                onChange={(value: string) => setValue(value)}
                placeholder={placeholder}
                style={style}
            />
        </Form.Item>
    );
};

export default React.memo(FormInputFormItem);
